module.exports = __webpack_public_path__ + "static/media/orange-arrow-animation.44f22263.gif";